import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Starter from "./Pages/Index";
import Login from "./Pages/loginpage";
import Realdolead from "./Pages/RealDolead.jsx";
import 'flowbite';
import SAILead from "./Pages/SAILead.jsx";
import Client from "./Pages/Client.jsx";
import Project from "./Pages/Project.jsx";
import Property from "./Pages/Property.jsx";
import Broker from "./Pages/Broker.jsx";
import SMS from "./Pages/SMS.jsx";
import Whatsapp from "./Pages/Whatsapp.jsx";
import Staff from "./Pages/Staff.jsx";
import Audit from "./Pages/Audit.jsx";
import ProfilePage from "./Pages/ProfilePage.jsx";


function App() {
  
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" element={<Starter />} />
          <Route path="/login" element={<Login />} />
          <Route path="/real-do-leads" element={<Realdolead />} />
          <Route path="/sai-leads" element={<SAILead />} />
          <Route path="/clients" element={<Client />} />
          <Route path="/property" element={<Property />} />
          <Route path="/project" element={<Project />} />
          <Route path="/broker" element={<Broker />} />
          <Route path="/sms-template" element={<SMS />} />
          <Route path="/wp-template" element={<Whatsapp />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
